(function () {
    'use strict';

    angular
        .module('financial')
        .controller('ClientCreditsController', ClientCreditsController);

    ClientCreditsController.$inject = ['ClientService', 'AdmService', '$uibModal', '$scope'];


    function ClientCreditsController(ClientService, AdmService, $uibModal, $scope) {
        var vm              = this;

        vm.getByFilter      = getByFilter;
        vm.userName         = '';
        vm.userEmail        = '';
        vm.userSearch       = '';
        vm.controlId        = '';
        vm.flaf             = false;
        vm.noResultMessage  = '';
        vm.formatDate       = formatDate;
        vm.detailCredit     = detailCredit;
        vm.deleteCredit     = deleteCredit;
        vm.useCredit        = useCredit;
        vm.createCredit     = createCredit;
        vm.editCredit       = editCredit;
        vm.sellers          = [];
        vm.sellerSelected   = '';
        vm.loadSellers      = loadSellers;
        vm.usedOptions      = [
            { id: -1, name: '--- All ---' },
            { id: 1, name: 'Used' },
            { id: 2, name: 'Not used' },
        ];
        vm.selectedUsedOption = -1;

        // Pagination
        vm.pageChanged      = pageChanged;
        vm.setPage          = setPage;
        vm.page             = 1;
        vm.flag             = false;
        vm.noResultMessage  = '';
        vm.to               = null;

        function loadSellers() {
            AdmService.getSellers().then(function(response) {
                vm.sellers = response.data;
            }).catch(function(err) {
            });
        }
        
        function getByFilter () {

            let query = {};
            if (vm.controlId != '') {
                query['control_id'] = vm.controlId;
            }
            if (vm.userName != '') {
                query['user_name'] = vm.userName;
            }
            if (vm.userEmail != '') {
                query['user_email'] = vm.userEmail;
            }
            if (vm.userSearch != '') {
                query['user_search'] = vm.userSearch;
            }
            if (vm.sellerSelected) {
                query['seller_id'] = vm.sellerSelected;
            }
            if (vm.selectedUsedOption !== -1) {
                query['used'] = vm.selectedUsedOption;
            }

            console.log(query);
            query['page'] = vm.page;

            ClientService.getClientCredits(query).then(function(response) {
                vm.flag = false;
                vm.noResultMessage = 'Searching, wait a moment...';
                vm.userCredits = response.data.data;
                if(vm.userCredits.length == 0){
                    vm.noResultMessage = 'Sorry, no results were found!';
                    vm.flag = false;
                } else {
                    vm.noResultMessage = '';
                    vm.flag = true;
                }
                vm.totalItems = response.data.total;
                vm.to         = response.data.to;
                vm.setPage(response.data.current_page);
                vm.itemsPerPage = response.data.per_page;
            });
        }

        function detailCredit (credit) {
            $uibModal.open({
                templateUrl: 'templates/financial/report/client-credits/detail/detail.modal.html',
                controller: 'ClientCreditsDetailModalController',
                controllerAs:'clientCreditsDetail',
                size: 'md',
                resolve: {
                    credit: function () {
                        return credit
                    }
                }
            });
        }

        function useCredit (credit) {
            $uibModal.open({
                templateUrl: 'templates/financial/report/client-credits/use/use.modal.html',
                controller: 'ClientCreditsUseModalController',
                controllerAs:'clientCreditsUse',
                size: 'md',
                resolve: {
                    credit: function () {
                        return credit
                    },
                    clientCredits: function () {
                        return vm;
                    }
                }
            });
        }

        function deleteCredit (credit) {
            $uibModal.open({
                templateUrl: 'templates/financial/report/client-credits/delete/delete.modal.html',
                controller: 'ClientCreditsDeleteModalController',
                controllerAs:'clientCreditsDelete',
                size: 'md',
                resolve: {
                    credit: function () {
                        return credit
                    },
                    clientCredits: function () {
                        return vm;
                    }
                }
            });
        }

        function createCredit () {
            $uibModal.open({
                templateUrl: 'templates/financial/report/client-credits/create/create.modal.html',
                controller: 'ClientCreditsCreateModalController',
                controllerAs:'clientCreditsCreate',
                size: 'md',
                resolve: {
                    clientCredits: function () {
                        return vm;
                    }
                }
            });
        }

        function editCredit (credit) {
            $uibModal.open({
                templateUrl: 'templates/financial/report/client-credits/edit/edit.modal.html',
                controller: 'ClientCreditsEditModalController',
                controllerAs:'clientCreditsEdit',
                size: 'md',
                resolve: {
                    clientCredits: function () {
                        return vm;
                    },
                    credit: function () {
                        return credit;
                    }
                }
            });
        }

        function setPage(page) {
            vm.currentPage = page;
        }

        function pageChanged(page) {
            vm.page = vm.currentPage;
            vm.getByFilter(false);
        }

        function activate () {
            vm.getByFilter();
            vm.loadSellers();
        }

        activate();
    }

})();